// import { BackgroundBoxes } from "@/components/ui/background-boxes";
import { Button } from "@/components/ui/button";
import { useUser } from "@/hooks/useUser";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
// import SnbpSvg from "@/assets/illustrations/snbp.svg";
// import SnbtSvg from "@/assets/illustrations/snbt.svg";
// import SmbjmSvg from "@/assets/illustrations/smbjm.svg";
import LogoSNBP from "@/assets/logos/snbp.png";
import LogoSNBT from "@/assets/logos/snbt.png";
// import {
//   GlowingStarsBackgroundCard,
//   GlowingStarsDescription,
//   GlowingStarsTitle,
// } from "@/components/ui/glowing-stars";
import Combobox from "@/components/Combobox";
import FormHeader from "@/components/FormHeader";
import InputError from "@/components/InputError";
import Modal from "@/components/Modal";
import SegmentedInput from "@/components/SegmentedInput";
import SkeletonCard from "@/components/SkeletonCard";
import { Badge } from "@/components/ui/badge";
import { Checkbox } from "@/components/ui/checkbox";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { MultiSelect } from "@/components/ui/multi-select";
import { web } from "@/config/System";
import { useCountdown } from "@/hooks/useCountdown";
import { useDebounce } from "@/hooks/useDebounce";
import useSessionStorage from "@/hooks/useSessionStorage";
import api from "@/lib/axios";
import { formatDateIndonesia } from "@/lib/utils";
import {
  getDataSekolahAsal,
  getDataSiswa,
  getListJurusanSekolah,
  getListKomponenDashboardSiswa,
  getListMapelKumer,
  getListPerguruanTinggi,
  getListPerguruanTinggiProdi,
  getListSekolah,
} from "@/services/getData";
import {
  DataMapelPeminatan,
  DataSiswa,
  JenjangPendidikan,
  JurusanSekolah,
  MapelPeminatanKumer,
  Option,
  PerguruanTinggi,
  PerguruanTinggiProdi,
  Periode,
  Sekolah,
  SysProgramStudi,
} from "@/types";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { AxiosError } from "axios";
import {
  AlertTriangle,
  ArrowRight,
  Clock,
  ExternalLink,
  Info,
  Layers,
  Lightbulb,
  Loader2,
  MessageCircle,
  Search,
  X,
} from "lucide-react";
import { useEffect, useRef, useState } from "react";
import { flushSync } from "react-dom";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { FaFaceFrown } from "react-icons/fa6";
import { MdWarning } from "react-icons/md";
import FormSekolahLab from "./partial/FormSekolahLab";
import FormSkorUTBK from "./partial/FormSkorUTBK";
import FormStudentExchange from "./partial/FormStudentExchange";
import { PeriodeItem } from "./partial/PeriodeItem";
import { LuDownload } from "react-icons/lu";

export type InputState = {
  id_sys_periode: string;
  nama_lengkap: string;
  nisn: string;
  id_ref_sekolah: string;
  id_ref_jurusan_sekolah: string;
  is_kurikulum_merdeka: boolean | null | number;
  nomor_utbk?: string;
  uk_id?: string;
  asal_pt?: string;
  asal_prodi?: string;
  nim?: string;
  tahun_ijazah?: string;
  list_id_ref_mapel_peminatan_kurikulum_merdeka?: string[];
  tanggal_lahir?: string;
  jenjang_pendidikan_terakhir_daftar_rpl?: "sma" | "diploma" | null;
  id_ref_daftar_program?: string;
};

const listContentJalur = [
  {
    nama: "SNBP",
    description:
      "Penjaringan siswa secara nasional berdasarkan prestasi dengan nilai rapor dan prestasi akademik/non akademik lainnya.",
    icon: LogoSNBP,
  },
  {
    nama: "SNBT",
    description:
      "Penjaringan siswa secara nasional berdasarkan hasil tes UTBK, yang berfokus pada kemampuan penalaran dan pemecahan masalah.",
    icon: LogoSNBT,
  },
  {
    nama: "SMBJM-SKOR-UTBK",
    description:
      "Seleksi Mandiri Berbasis Jalur Mandiri dengan Skor UTBK, memungkinkan calon mahasiswa untuk mendaftar menggunakan nilai Ujian Tulis Berbasis Komputer (UTBK) sebagai indikator kelulusan.",
    icon: web.logo,
  },
  {
    nama: "SMBJM-CBT",
    description:
      "Seleksi Mandiri Berbasis Jalur Mandiri menggunakan metode Computer Based Test (CBT), memberikan kesempatan kepada calon mahasiswa untuk mengikuti ujian secara langsung di lokasi yang ditentukan.",
    icon: web.logo,
  },
  {
    nama: "SMBJM-NILAI RAPORT",
    description:
      "Jalur mandiri yang dikhususkan bagi calon mahasiswa dengan prestasi akademik atau non-akademik di berbagai bidang. Pastikan berkas pendukung prestasi Anda lengkap.",
    icon: web.logo,
  },
  {
    nama: "SMBJM-TALENT SCOUTING",
    description:
      "Jalur mandiri yang ditujukan bagi calon mahasiswa dengan bakat atau keterampilan khusus di bidang akademik maupun non-akademik. Seleksi didasarkan pada pencapaian dan potensi yang dimiliki.",
    icon: web.logo,
  },
  {
    nama: "Alih Kredit",
    description:
      "Jalur penerimaan mahasiswa untuk program alih kredit bagi mereka yang telah menyelesaikan sebagian pendidikan di institusi lain dan ingin melanjutkan di sini.",
    icon: web.logo,
  },
  {
    nama: "Program Pascasarjana",
    description:
      "Jalur penerimaan untuk program magister (S2) dan doktoral (S3), dirancang untuk calon mahasiswa yang ingin melanjutkan pendidikan ke jenjang lebih tinggi.",
    icon: web.logo,
  },
  {
    nama: "Profesi",
    description:
      "Jalur penerimaan untuk program pendidikan profesi, dirancang bagi calon mahasiswa yang ingin memperoleh keahlian dan sertifikasi di bidang tertentu",
    icon: web.logo,
  },
  {
    nama: "International Admission Track",
    description:
      "Jalur penerimaan khusus untuk program internasional yang dirancang bagi mahasiswa yang ingin mengejar pendidikan dengan standar global.",
    icon: web.logo,
  },
  {
    nama: "Afirmasi",
    description:
      "Jalur khusus yang memberikan kesempatan kepada calon mahasiswa dari daerah 3T (Tertinggal, Terdepan, dan Terluar) atau kategori afirmasi lainnya untuk melanjutkan pendidikan tinggi.",
    icon: web.logo,
  },
];

function renderWarningMessage(message: string) {
  return message.split(/(\*b.*?\*b)/).map((part, index) => {
    if (part.startsWith("*b") && part.endsWith("*b")) {
      return <strong key={index}>{part.slice(2, -2)}</strong>;
    }
    return part;
  });
}

const cekAksesPendaftaran = async ({
  id_sys_periode,
}: {
  id_sys_periode: string;
}) => {
  const response = await api.post("/siswa/cek-akses-pendaftaran", {
    id_sys_periode,
  });
  return response.data;
};

export const storeDataPendaftaran = async (newData: InputState) => {
  const response = await api.post(
    "/siswa/penerimaan/smbjm/pendaftaran/store",
    newData,
  );
  return response.data;
};

const jenjangMap: Record<string, string> = {
  D3: "Diploma",
  D4: "Applied Bachelor’s Degree (D4)",
  S1: "Bachelor's Degree",
  S2: "Master's Degree",
  "S2 Terapan": "Applied Master's Degree",
  S3: "Doctoral Degree",
};

export default function DashboardSiswaPage() {
  const { t } = useTranslation();

  const { user } = useUser();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [_, setSessionPeriode] = useSessionStorage("sessionPeriode", {
    id_sys_periode: "",
  });

  const tagParams = searchParams.get("tag") ?? "";
  const HIDE_FILTER = tagParams === "student" || tagParams === "international";

  const searchQueryRef = useRef<HTMLInputElement | null>(null);

  const [showWarning, setShowWarning] = useState(false);
  const [warningMessage, setWarningMessage] = useState("");
  const [showPopupJalurMandiri, setShowPopupJalurMandiri] = useState(false);
  const [showConfirmDaftar, setShowConfirmDaftar] = useState(false);
  const [selectedPeriode, setSelectedPeriode] = useState<Periode | null>(null);
  const [form, setForm] = useState<InputState>({
    id_sys_periode: selectedPeriode?.id_sys_periode || "",
    nama_lengkap: "",
    nisn: "",
    id_ref_sekolah: "",
    id_ref_jurusan_sekolah: "",
    is_kurikulum_merdeka: null,
    nomor_utbk: "",
    uk_id: "",
    asal_pt: "",
    asal_prodi: "",
    nim: "",
    tahun_ijazah: "",
    list_id_ref_mapel_peminatan_kurikulum_merdeka: [],
    tanggal_lahir: "",
    jenjang_pendidikan_terakhir_daftar_rpl: null,
  });

  const [selectedJenjang, setSelectedJenjang] = useState("");
  const [openListJenjang, setOpenListJenjang] = useState(false);
  const [openListProdi, setOpenListProdi] = useState(false);
  const [openListJurusan, setOpenListJurusan] = useState(false);
  const [openListSekolah, setOpenListSekolah] = useState(false);
  const [searchQuerySekolah, setSearchQuerySekolah] = useState("");
  const [selectedSekolah, setSelectedSekolah] = useState<
    (Option & { bentuk_pendidikan: string }) | null
  >(null);
  const [openAsalUniversitas, setOpenAsalUniversitas] = useState(false);
  const [openAsalProdi, setOpenAsalProdi] = useState(false);
  const [searchQueryUniversitas, setSearchQueryUniversitas] = useState("");
  const [selectedAsalUniversitas, setSelectedAsalUniversitas] = useState<
    (Option & { nama_singkat: string }) | null
  >(null);
  const [searchQuery, setSearchQuery] = useState(searchParams.get("tag") || "");
  const [selectedMapels, setSelectedMapels] = useState<string[]>([]);
  const [isConfirm, setIsConfirm] = useState(false);

  const [linkTelegram, setLinkTelegram] = useState("");
  const [waktuMulaiIsiUkt, setWaktuMulaiIsiUkt] = useState<string | null>(null);
  const { countdown: countdownIsiUKT, isReady: isReadyIsiUKT } =
    useCountdown(waktuMulaiIsiUkt);
  const {
    countdown: countdownWaktuPengumumanKelulusan,
    isReady: isReadyPengumumanKelulusan,
  } = useCountdown(selectedPeriode?.waktu_pengumuman_kelulusan || "");
  const isJalurGrupSMBJM =
    selectedPeriode?.jalur_jenis?.jalur_grup?.nama_jalur_grup ==
    "Jalur Mandiri SMBJM";

  const countdown = isJalurGrupSMBJM
    ? countdownWaktuPengumumanKelulusan
    : countdownIsiUKT;
  const isReady = isJalurGrupSMBJM ? isReadyPengumumanKelulusan : isReadyIsiUKT;

  const debouncedSearchQuery = useDebounce(searchQuery, 1000);
  const debouncedQueryUniversitas = useDebounce(searchQueryUniversitas, 1000);
  const debouncedSearchQuerySekolah = useDebounce(searchQuerySekolah, 1000);

  const isJalurInternasional =
    selectedPeriode &&
    selectedPeriode?.jalur_jenis?.nama_jalur_jenis_slug == "internasional";
  const isJalurStudentExchange =
    selectedPeriode?.jalur_jenis?.nama_jalur_jenis_slug == "studentexchange";
  const isJalurSkorUTBK =
    selectedPeriode?.jalur_jenis?.nama_jalur_jenis_slug == "skorutbk";
  const isJalurSekolahLab =
    selectedPeriode?.jalur_jenis?.nama_jalur_jenis_slug == "sekolahlab";

  const { data, isPending } = useQuery({
    queryKey: ["listKomponenDashboardSiswa", debouncedSearchQuery],
    queryFn: () => getListKomponenDashboardSiswa(debouncedSearchQuery),
  });

  const { data: dataSiswa } = useQuery<DataSiswa>({
    queryKey: ["dataSiswa", user?.id],
    queryFn: () => getDataSiswa(),
    enabled: !!user?.id,
  });

  const { data: optionsPt, isPending: isPendingOptionsPt } = useQuery({
    queryKey: ["listPerguruanTinggi", debouncedQueryUniversitas, form.asal_pt],
    queryFn: () => getListPerguruanTinggi("1", "1", `${web.univAcronym}`),
    select: (data) => {
      if (!data) return [];
      return data?.map((item: PerguruanTinggi) => ({
        label: item.nama_perguruan_tinggi,
        value: `${item.id_feeder}`,
        nama_singkat: item.nama_singkat,
      }));
    },
  });

  const { data: dataAsalProdi } = useQuery({
    queryKey: ["listAsalProdi", form.asal_pt],
    queryFn: () => getListPerguruanTinggiProdi("1", "1000", form.asal_pt || ""),
    select: (data) => {
      return data?.map((item: PerguruanTinggiProdi) => ({
        label: `${item.nama_program_studi} (${item.nama_jenjang_pendidikan})`,
        value: `${item.id_feeder}`,
        nama_jenjang_pendidikan: item.nama_jenjang_pendidikan,
      }));
    },
    enabled: !!form.asal_pt,
  });

  const optionsAsalProdi = dataAsalProdi
    ? dataAsalProdi?.filter((item: Option) => {
        return (
          item.nama_jenjang_pendidikan === "S1" ||
          item.nama_jenjang_pendidikan === "D4"
        );
      })
    : [];

  const { data: dataSekolah, isPending: isPendingSekolah } = useQuery({
    queryKey: [
      "listSekolah",
      debouncedSearchQuerySekolah,
      form.id_ref_sekolah,
      isJalurSekolahLab,
    ],
    queryFn: () =>
      getListSekolah(
        "1",
        "10",
        isJalurSekolahLab
          ? "50100394"
          : debouncedSearchQuerySekolah
            ? debouncedSearchQuerySekolah
            : form.id_ref_sekolah,
      ),
    select: (data) =>
      data?.data?.map((sekolah: Sekolah) => ({
        label: `${sekolah.nama_sekolah} (${sekolah.npsn_sekolah})`,
        value: `${sekolah.id_ref_sekolah}`,
        bentuk_pendidikan: sekolah.bentuk_pendidikan,
      })),
  });

  const { data: listJurusan, isPending: isPendingListJurusan } = useQuery({
    queryKey: ["listJurusan", selectedSekolah],
    queryFn: () => getListJurusanSekolah(selectedSekolah?.bentuk_pendidikan),
    select: (data) =>
      data?.map((jurusan: JurusanSekolah) => ({
        label: jurusan.nama_jurusan_sekolah,
        value: `${jurusan.id_ref_jurusan_sekolah}`,
      })),
    enabled: !!selectedSekolah,
  });

  const filteredListJurusan = listJurusan?.filter((option: Option) => {
    return !option?.label?.startsWith("Umum");
  });

  // const { data: listJurusanAll } = useQuery({
  //   queryKey: ["listJurusan"],
  //   queryFn: () => getListJurusanSekolah(),
  //   select: (data) =>
  //     data?.map((jurusan: JurusanSekolah) => ({
  //       label: jurusan.nama_jurusan_sekolah,
  //       value: `${jurusan.id_ref_jurusan_sekolah}`,
  //     })),
  // });

  const { data: dataSekolahAsal } = useQuery<DataSiswa>({
    queryKey: ["dataSekolahAsal", user?.id],
    queryFn: () => getDataSekolahAsal(),
    enabled: !!user?.id,
  });

  const { data: listMapelPeminatan } = useQuery({
    queryKey: ["listMapelPeminatan"],
    queryFn: () => getListMapelKumer(),
    select: (data) =>
      data?.map((mapel: MapelPeminatanKumer) => ({
        label: `${mapel.nama_mapel}`,
        value: `${mapel?.idref_mapel_peminatan_kurikulum_merdeka}`,
      })),
  });

  const optionsProdi =
    selectedPeriode && selectedPeriode?.sys_prodi
      ? selectedPeriode?.sys_prodi.map((item: SysProgramStudi) => {
          return {
            label: isJalurInternasional
              ? `${item?.unitkerja?.name}`
              : `${item.unitkerja?.nama}`,
            value: `${item.uk_id}`,
            jenjang: `${item?.unitkerja?.uk_program}`,
          } as Option;
        })
      : [];

  const queryClient = useQueryClient();
  const {
    mutate,
    isPending: isPendingStorePendaftaran,
    error,
  } = useMutation({
    mutationFn: storeDataPendaftaran,
    onSuccess: (data) => {
      flushSync(() => {
        setSessionPeriode({ id_sys_periode: data?.data?.id_sys_periode });
      });

      queryClient.invalidateQueries({ queryKey: ["dataStep"] });
      queryClient.invalidateQueries({ queryKey: ["dataPendaftaran"] });
      queryClient.invalidateQueries({ queryKey: ["dataSiswa"] });
      navigate(
        tagParams
          ? `${data?.data?.redirect_url}?tag=${tagParams}`
          : data?.data?.redirect_url,
      );
      toast.success(data?.message || "Success.");
    },
    onError: (
      error: AxiosError<{
        message?: string;
        errors?: Record<string, string[]>;
      }>,
    ) => {
      setShowConfirmDaftar(false);

      const err = error as AxiosError<{
        message?: string;
        errors?: Record<string, string[]>;
      }>;
      const errorMessage =
        err.response?.data?.message || "An unexpected error occurred.";
      toast.error(errorMessage);
    },
  });
  const {
    mutate: mutateCekAksesPendaftaran,
    isPending: isPendingCekAksesPendaftaran,
  } = useMutation({
    mutationFn: cekAksesPendaftaran,
    onSuccess: (data) => {
      flushSync(() => {
        setSessionPeriode({ id_sys_periode: data?.data?.id_sys_periode });
      });

      if (!data?.data?.dataPendaftaran) {
        setShowPopupJalurMandiri(true);
        setForm((prev) => ({
          ...prev,
          id_sys_periode: data?.data?.id_sys_periode,
        }));
        return;
      }

      navigate(
        tagParams
          ? `${data?.data?.redirect_url}?tag=${tagParams}`
          : data?.data?.redirect_url,
      );
    },
    onError: (
      error: AxiosError<{
        message?: string;
        errors?: Record<string, string[]>;
        data?: {
          waktu_mulai_isi_ukt?: string;
          id_sys_periode?: string;
          link_telegram?: string;
        };
      }>,
    ) => {
      const waktuMulaiIsiUkt =
        error?.response?.data?.data &&
        error?.response?.data?.data?.waktu_mulai_isi_ukt;
      if (waktuMulaiIsiUkt) {
        setWaktuMulaiIsiUkt(waktuMulaiIsiUkt);
        setSessionPeriode({
          id_sys_periode: error?.response?.data?.data?.id_sys_periode || "",
        });
        setForm((prev) => ({
          ...prev,
          id_sys_periode: error?.response?.data?.data?.id_sys_periode || "",
        }));
        setLinkTelegram(error?.response?.data?.data?.link_telegram || "");
      }

      const err = error as AxiosError<{
        message?: string;
        errors?: Record<string, string[]>;
      }>;
      const errorMessage =
        err.response?.data?.message || "An unexpected error occurred.";

      setShowWarning(true);
      setWarningMessage(errorMessage);
      toast.error(errorMessage);
    },
  });

  const handleSubmitPendaftaran = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    let data = { ...form };

    data = {
      ...form,
      list_id_ref_mapel_peminatan_kurikulum_merdeka: selectedMapels,
    };

    mutate(data);
  };

  useEffect(() => {
    if (!user && !dataSiswa) return;
    setForm((prev) => ({
      ...prev,
      nama_lengkap: user?.nama_lengkap || "",
      nisn: dataSiswa?.nisn || "",
      tanggal_lahir: dataSiswa?.tanggal_lahir || "",
      id_ref_sekolah: dataSiswa?.id_ref_sekolah || "",
    }));
  }, [user, dataSiswa, dataSiswa?.tanggal_lahir]);

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === "/") {
        event.preventDefault();
        searchQueryRef.current?.focus();
      }
    };

    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  useEffect(() => {
    if (dataSekolahAsal) {
      setForm((prev) => ({
        ...prev,
        id_ref_sekolah: prev.id_ref_sekolah
          ? prev.id_ref_sekolah
          : dataSekolahAsal.id_ref_sekolah || "",
        is_kurikulum_merdeka:
          prev.is_kurikulum_merdeka !== null
            ? prev.is_kurikulum_merdeka
            : dataSekolahAsal.is_kurikulum_merdeka === 0
              ? false
              : dataSekolahAsal.is_kurikulum_merdeka === 1
                ? true
                : null,
        id_ref_jurusan_sekolah: prev.id_ref_jurusan_sekolah
          ? prev.id_ref_jurusan_sekolah
          : dataSekolahAsal?.id_ref_jurusan_sekolah || "",
      }));
      const listIdMapelPeminatan = dataSekolahAsal?.data_mapel_peminatan?.map(
        (dataMapelPeminatan: DataMapelPeminatan) => {
          return `${dataMapelPeminatan.idref_mapel_peminatan_kurikulum_merdeka}`;
        },
      );
      setSelectedMapels(listIdMapelPeminatan as string[]);
    }
  }, [dataSekolahAsal]);

  useEffect(() => {
    const currentSekolah = dataSekolah?.find((option: Option) => {
      return option.value == form.id_ref_sekolah;
    });
    setSelectedSekolah(currentSekolah);
  }, [dataSekolah]);

  const isSMA =
    selectedSekolah &&
    (selectedSekolah?.bentuk_pendidikan?.startsWith("SMA") ||
      selectedSekolah?.bentuk_pendidikan?.startsWith("MA"));
  const isSMK =
    selectedSekolah && selectedSekolah?.bentuk_pendidikan?.startsWith("SMK");
  // const isPKBM =
  //   selectedSekolah && selectedSekolah?.bentuk_pendidikan?.startsWith("PKBM");

  const currentMapels =
    selectedMapels?.length > 0
      ? (listMapelPeminatan?.filter((option: Option) =>
          selectedMapels.includes(option.value),
        ) ?? [])
      : [];
  const currentJurusan = listJurusan?.find((option: Option) => {
    return option.value == form.id_ref_jurusan_sekolah;
  });

  const { i18n } = useTranslation();

  const optionsJenjang =
    i18n.language == "en"
      ? [
          { label: "Applied Bachelor’s Degree (D4)", value: "D4" },
          { label: "Bachelor's Degree (S1)", value: "S1" },
          { label: "Master's Degree (S2)", value: "S2" },
          { label: "Doctoral Degree (S3)", value: "S3" },
        ]
      : [
          { label: "Magister (S2)", value: "S2" },
          { label: "Doktor (S3)", value: "S3" },
        ];

  const filteredOptionsJenjang = selectedPeriode
    ? optionsJenjang.filter((option: Option) => {
        return selectedPeriode.jenjang_buka?.some(
          (jenjang: JenjangPendidikan) =>
            jenjang.nama_jenjang_pendidikan === option.value,
        );
      })
    : [];

  const filteredOptionsProdi = selectedJenjang
    ? (optionsProdi?.filter((option: Option) => {
        return (
          typeof (option as any).jenjang === "string" &&
          (option as any).jenjang.includes(selectedJenjang)
        );
      }) ?? [])
    : (optionsProdi ?? []);

  return (
    <main>
      <section className="relative my-8 py-16 px-6 md:px-12 bg-gradient-to-b from-slate-50 to-white dark:from-slate-900 dark:to-slate-950 border border-slate-100 dark:border-slate-800 rounded-[2.5rem] overflow-hidden shadow-sm transition-colors duration-300">
        {/* Decorative Background Elements */}
        <div className="absolute top-0 right-0 -mt-20 -mr-20 w-80 h-80 bg-blue-100/50 dark:bg-blue-900/20 rounded-full blur-3xl opacity-60 pointer-events-none" />
        <div className="absolute bottom-0 left-0 -mb-20 -ml-20 w-60 h-60 bg-indigo-100/50 dark:bg-indigo-900/20 rounded-full blur-3xl opacity-60 pointer-events-none" />

        <div className="relative z-10 max-w-4xl mx-auto text-center space-y-6">
          {/* Greeting / Title */}
          <div className="space-y-3">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 text-xs font-medium text-slate-600 dark:text-slate-300 shadow-sm mb-2">
              <Lightbulb className="w-3.5 h-3.5 text-amber-500 fill-amber-500/20" />
              <span>{t("siswa.layout.dashboard.periode.tips")}</span>
            </div>

            <h1 className="text-3xl md:text-5xl font-extrabold tracking-tight text-slate-900 dark:text-white">
              {t("siswa.layout.dashboard.title")},{" "}
              <span className="text-primary">{user?.nama_lengkap}</span>
            </h1>

            <p className="text-lg md:text-xl text-slate-500 dark:text-slate-400 max-w-2xl mx-auto leading-relaxed">
              {t("siswa.layout.dashboard.description")}
            </p>
          </div>

          {/* Search Input Area */}
          {!HIDE_FILTER && (
            <div className="mt-10 relative max-w-2xl mx-auto group">
              {/* Glow Effect on Focus */}
              <div className="absolute -inset-1 bg-gradient-to-r from-blue-100 to-indigo-100 dark:from-blue-900/50 dark:to-indigo-900/50 rounded-full blur opacity-20 group-focus-within:opacity-70 transition duration-500" />

              <div className="relative">
                {/* Search Icon */}
                <div className="absolute left-5 top-1/2 -translate-y-1/2 text-slate-400 dark:text-slate-500">
                  <Search className="w-6 h-6" />
                </div>

                <Input
                  ref={searchQueryRef}
                  placeholder={
                    t("siswa.layout.dashboard.search") ||
                    "Cari jalur atau periode pendaftaran..."
                  }
                  className="w-full h-14 pl-14 pr-14 rounded-full border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-950 shadow-lg shadow-slate-100/50 dark:shadow-none text-lg placeholder:text-slate-400 dark:placeholder:text-slate-600 focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:border-transparent dark:text-white transition-all"
                  value={searchQuery}
                  onChange={(event) => setSearchQuery(event.target.value)}
                />

                {/* Keyboard Shortcut Hint */}
                <div className="absolute right-4 top-1/2 -translate-y-1/2 pointer-events-none">
                  <kbd className="hidden sm:inline-flex h-7 items-center gap-1 rounded border border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-800 px-2 font-mono text-[10px] font-medium text-slate-500 dark:text-slate-400">
                    <span className="text-xs">/</span>
                  </kbd>
                </div>
              </div>
            </div>
          )}
        </div>
      </section>

      {/* SEARCH RESULTS FEEDBACK */}
      {!HIDE_FILTER && debouncedSearchQuery && (
        <section className="mb-10 animate-in fade-in slide-in-from-top-4 duration-300">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4 p-4 bg-slate-50 dark:bg-slate-900 border border-slate-200 dark:border-slate-800 rounded-2xl max-w-4xl mx-auto">
            <div className="flex items-center gap-3">
              <div className="flex h-10 w-10 items-center justify-center rounded-full bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 shadow-sm">
                <Search className="h-5 w-5 text-blue-600 dark:text-blue-400" />
              </div>
              <div>
                <p className="text-sm text-slate-500 dark:text-slate-400 font-medium">
                  {t("siswa.layout.dashboard.search.result.label") ||
                    "Menampilkan hasil pencarian untuk:"}
                </p>
                <p className="text-lg font-bold text-slate-900 dark:text-white">
                  "{debouncedSearchQuery}"
                </p>
              </div>
            </div>

            <Button
              variant="ghost"
              size="sm"
              onClick={() => setSearchQuery("")}
              className="text-slate-500 dark:text-slate-400 hover:text-red-600 dark:hover:text-red-400 hover:bg-red-50 dark:hover:bg-red-950/30 rounded-full px-4"
            >
              <X className="w-4 h-4 mr-2" />
              {t("siswa.layout.dashboard.search.result.delete") ||
                "Hapus Pencarian"}
            </Button>
          </div>
        </section>
      )}

      {isPending ? (
        <SkeletonCard />
      ) : (
        <>
          {/* DATA EXISTS */}
          {data && Object.keys(data?.listPeriode)?.length > 0 ? (
            <div className="space-y-12 pb-20">
              {" "}
              {/* Spacing antar section jalur */}
              {Object.keys(data?.listPeriode).map((namaJalur) => {
                // 1. Logic pencarian konten (Icon/Deskripsi) diperbaiki
                // Agar lebih robust mencocokkan string dari backend dengan config frontend
                const contentJalur = listContentJalur.find((content) => {
                  const backendName = namaJalur.toLowerCase();
                  const configName = content.nama.toLowerCase();

                  // Cek exact match, atau saling mengandung kata (contains)
                  return (
                    backendName === configName ||
                    backendName.includes(configName) ||
                    configName.includes(backendName)
                  );
                });

                // Ambil array periode berdasarkan key namaJalur
                const listPeriodeItem = data?.listPeriode[namaJalur] || [];
                const jumlahPeriode = listPeriodeItem.length;

                return (
                  // WRAPPER "PULAU" (Boxed Section)
                  <section
                    key={namaJalur}
                    className="group relative rounded-3xl overflow-hidden border border-slate-200 dark:border-slate-800 bg-slate-50/50 dark:bg-slate-900/50 p-6 md:p-8 transition-all hover:border-slate-300 dark:hover:border-slate-700 hover:bg-white dark:hover:bg-slate-900 hover:shadow-sm"
                  >
                    {/* SECTION HEADER */}
                    <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-8 border-b border-slate-200 dark:border-slate-800 pb-4">
                      <div className="flex items-center gap-4">
                        {/* Icon Container */}
                        <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-white dark:bg-slate-800 shadow-sm border border-slate-100 dark:border-slate-700 text-primary dark:text-blue-400">
                          {/* 2. Hapus hardcoded (namaJalur.startsWith...) 
                            Cukup cek apakah di config ditemukan icon untuk jalur ini
                        */}
                          {contentJalur?.icon ? (
                            <img
                              src={contentJalur?.icon}
                              alt={namaJalur}
                              className="w-8 h-8 object-contain"
                            />
                          ) : (
                            // Default icon jika tidak ada gambar khusus di config
                            <Layers className="w-6 h-6 text-slate-400 dark:text-slate-500" />
                          )}
                        </div>

                        <div>
                          <h2 className="text-2xl font-extrabold text-slate-800 dark:text-white tracking-tight">
                            {namaJalur}
                          </h2>
                          {/* Opsional: Jika ingin deskripsi dinamis dari config juga 
                            <p>{contentJalur?.deskripsi}</p>
                        */}
                          <p className="text-sm text-slate-500 dark:text-slate-400 font-medium hidden md:block">
                            {t("siswa.layout.dashboard.periode.text")}
                          </p>
                        </div>
                      </div>

                      {/* Badge Counter */}
                      <Badge
                        variant="secondary"
                        className="w-fit bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 text-slate-600 dark:text-slate-300 px-3 py-1 shadow-sm h-8"
                      >
                        {jumlahPeriode} Periode Tersedia
                      </Badge>
                    </div>

                    {/* GRID CONTENT */}
                    {/* items-stretch memaksa card PeriodeItem sama tinggi */}
                    <div className="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-6 items-stretch">
                      {listPeriodeItem.map((periode: Periode) => (
                        <PeriodeItem
                          key={periode.id_sys_periode}
                          periode={periode}
                          namaJalur={
                            periode.jalur_jenis?.nama_jalur_jenis || ""
                          }
                          contentJalur={contentJalur}
                          jenjangMap={jenjangMap}
                          isPending={isPendingCekAksesPendaftaran}
                          isSelected={
                            selectedPeriode?.id_sys_periode ===
                            periode.id_sys_periode
                          }
                          onSelect={() => {
                            setForm((prev) => ({
                              ...prev,
                              id_sys_periode: periode.id_sys_periode,
                            }));
                            setSelectedPeriode(periode);
                            mutateCekAksesPendaftaran({
                              id_sys_periode: periode.id_sys_periode,
                            });
                          }}
                        />
                      ))}
                    </div>
                  </section>
                );
              })}
            </div>
          ) : (
            // NOT FOUND STATE
            <div className="flex flex-col items-center justify-center py-24 rounded-3xl border-2 border-dashed border-slate-200 dark:border-slate-800 bg-slate-50 dark:bg-slate-900 text-center px-4">
              <div className="w-20 h-20 bg-slate-100 dark:bg-slate-800 rounded-full flex items-center justify-center mb-6">
                <FaFaceFrown
                  size={40}
                  className="text-slate-400 dark:text-slate-500"
                />
              </div>
              <h3 className="font-bold text-2xl text-slate-700 dark:text-slate-200">
                {t("siswa.layout.dashboard.search.result.notfound")}
              </h3>
              <p className="text-slate-500 dark:text-slate-400 mt-2 max-w-md">
                Maaf, kami tidak dapat menemukan periode pendaftaran yang Anda
                cari saat ini.
              </p>
            </div>
          )}
        </>
      )}

      <Modal
        show={showWarning}
        onClose={() => setShowWarning(false)}
        className="w-[95vw] sm:w-[32rem] p-0 overflow-hidden bg-white dark:bg-slate-950 flex flex-col max-h-[90vh]"
      >
        {/* --- KONTEN SCROLLABLE --- */}
        <div
          key={selectedPeriode?.id_sys_periode}
          className="overflow-y-auto flex-1 custom-scrollbar"
        >
          {/* --- HEADER --- */}
          <div className="bg-amber-50 dark:bg-amber-900/20 p-6 flex flex-col items-center justify-center border-b border-amber-100 dark:border-amber-800/50 text-center relative shrink-0">
            <div className="absolute top-0 left-0 w-full h-1 bg-amber-500"></div>
            <div className="w-14 h-14 bg-amber-100 dark:bg-amber-800/50 rounded-full flex items-center justify-center mb-3">
              <AlertTriangle className="w-7 h-7 text-amber-600 dark:text-amber-500" />
            </div>
            <h2 className="text-xl font-bold text-slate-900 dark:text-white">
              Perhatian & Informasi
            </h2>
            {/* <p className="text-sm text-amber-700 dark:text-amber-400 mt-1 px-4">
              Mohon baca informasi berikut sebelum melanjutkan proses daftar.
            </p> */}
          </div>

          {/* --- BODY --- */}
          <div className="p-6 space-y-6">
            {/* Box Countdown */}
            <div className="flex flex-col items-center space-y-3 pt-2">
              <p className="text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-widest flex items-center gap-1.5">
                <Clock className="w-3.5 h-3.5" /> Waktu Tersisa
              </p>
              <div className="flex items-center justify-center gap-2 sm:gap-3">
                <div className="flex flex-col items-center">
                  <div className="w-12 h-12 sm:w-14 sm:h-14 flex items-center justify-center bg-slate-100 dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 shadow-inner">
                    <span className="text-xl sm:text-2xl font-bold text-slate-800 dark:text-slate-100">
                      {countdown?.days || "00"}
                    </span>
                  </div>
                  <span className="text-[10px] sm:text-xs font-medium text-slate-500 mt-1.5 uppercase">
                    Hari
                  </span>
                </div>
                <span className="text-xl font-bold text-slate-300 dark:text-slate-600 self-start mt-2 sm:mt-3">
                  :
                </span>

                <div className="flex flex-col items-center">
                  <div className="w-12 h-12 sm:w-14 sm:h-14 flex items-center justify-center bg-slate-100 dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 shadow-inner">
                    <span className="text-xl sm:text-2xl font-bold text-slate-800 dark:text-slate-100">
                      {countdown?.hours || "00"}
                    </span>
                  </div>
                  <span className="text-[10px] sm:text-xs font-medium text-slate-500 mt-1.5 uppercase">
                    Jam
                  </span>
                </div>
                <span className="text-xl font-bold text-slate-300 dark:text-slate-600 self-start mt-2 sm:mt-3">
                  :
                </span>

                <div className="flex flex-col items-center">
                  <div className="w-12 h-12 sm:w-14 sm:h-14 flex items-center justify-center bg-slate-100 dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 shadow-inner">
                    <span className="text-xl sm:text-2xl font-bold text-slate-800 dark:text-slate-100">
                      {countdown?.minutes || "00"}
                    </span>
                  </div>
                  <span className="text-[10px] sm:text-xs font-medium text-slate-500 mt-1.5 uppercase">
                    Menit
                  </span>
                </div>
                <span className="text-xl font-bold text-slate-300 dark:text-slate-600 self-start mt-2 sm:mt-3">
                  :
                </span>

                <div className="flex flex-col items-center">
                  <div className="w-12 h-12 sm:w-14 sm:h-14 flex items-center justify-center bg-slate-100 dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 shadow-inner">
                    <span className="text-xl sm:text-2xl font-bold text-slate-800 dark:text-slate-100">
                      {countdown?.seconds || "00"}
                    </span>
                  </div>
                  <span className="text-[10px] sm:text-xs font-medium text-slate-500 mt-1.5 uppercase">
                    Detik
                  </span>
                </div>
              </div>
            </div>

            {/* Box Pesan Peringatan Dinamis */}
            <div className="p-4 rounded-xl border border-amber-200 bg-amber-50/50 dark:bg-amber-950/30 dark:border-amber-900/50 text-sm text-slate-700 dark:text-slate-300 leading-relaxed shadow-sm">
              {renderWarningMessage(warningMessage)}
            </div>

            {waktuMulaiIsiUkt && (
              <div className="space-y-6 animate-in fade-in slide-in-from-bottom-2 duration-500">
                {/* Box Grup Telegram */}
                {linkTelegram && (
                  <div className="bg-blue-50 dark:bg-blue-900/10 border border-blue-100 dark:border-blue-900/50 rounded-xl p-4 space-y-4">
                    <div className="flex gap-3 items-start">
                      <div className="p-2 bg-blue-100 dark:bg-blue-800/50 text-blue-600 dark:text-blue-400 rounded-lg shrink-0">
                        <MessageCircle className="w-5 h-5" />
                      </div>
                      <div>
                        <h3 className="font-bold text-slate-800 dark:text-slate-200 text-sm mb-1">
                          Grup Telegram Mahasiswa Baru
                        </h3>
                        <p className="text-xs text-slate-600 dark:text-slate-400 leading-relaxed">
                          Silakan bergabung ke grup Telegram Pendaftaran Kembali
                          Tahun 2026. Grup ini khusus untuk calon mahasiswa{" "}
                          {web.univAcronym} yang lulus.
                        </p>
                      </div>
                    </div>

                    <div className="bg-red-50 dark:bg-red-900/20 border border-red-100 dark:border-red-900/50 rounded-lg p-3 flex gap-2.5 items-start">
                      <Info className="w-4 h-4 text-red-600 dark:text-red-400 shrink-0 mt-0.5" />
                      <p className="text-[11px] text-red-700 dark:text-red-300 leading-relaxed">
                        <span className="font-bold">PENTING:</span> Jangan
                        bagikan tautan ini. Wajib menggunakan nama dan foto asli
                        pada profil Telegram Anda. Jika tidak sesuai, akses grup
                        akan ditolak.
                      </p>
                    </div>

                    <Link
                      to={linkTelegram}
                      target="_blank"
                      className="block w-full"
                    >
                      <Button
                        variant="outline"
                        className="w-full bg-white dark:bg-slate-900 border-blue-200 hover:bg-blue-50 hover:text-blue-700 dark:border-blue-800 dark:hover:bg-blue-900/40 text-blue-600 transition-colors"
                      >
                        <MessageCircle className="w-4 h-4 mr-2" />
                        Bergabung ke Grup Telegram
                      </Button>
                    </Link>
                    <Link
                      to={
                        "/panduan/Panduan-Pendaftaran-Kembali-SNBT-2026rv1.pdf"
                      }
                      target="_blank"
                      className="block w-full"
                      download
                    >
                      <Button
                        variant="default"
                        className="w-full bg-white dark:bg-slate-900 border-blue-200 hover:bg-blue-50 hover:text-blue-700 dark:border-blue-800 dark:hover:bg-blue-900/40 text-blue-600 transition-colors"
                      >
                        <LuDownload className="w-4 h-4 mr-2" />
                        Unduh Panduan
                      </Button>
                    </Link>
                  </div>
                )}

                {/* Action Button (Lanjutkan) */}
                {isReady && (
                  <div className="pt-4 border-t border-slate-100 dark:border-slate-800">
                    <Link to={"/daftar-kembali"} className="block w-full">
                      <Button
                        size="lg"
                        className="w-full text-base font-semibold group shadow-md transition-all hover:bg-primary/90"
                      >
                        Lanjutkan Daftar Kembali
                        <ArrowRight className="w-5 h-5 ml-2 group-hover:translate-x-1 transition-transform" />
                      </Button>
                    </Link>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>

        {/* --- FLOATING FOOTER (TOMBOL TUTUP) --- */}
        <div className="p-4 border-t border-slate-100 dark:border-slate-800 bg-slate-50 dark:bg-slate-900 shrink-0">
          <Button
            variant="outline"
            className="w-full h-11 text-slate-600 dark:text-slate-300 hover:bg-slate-200 dark:hover:bg-slate-800"
            onClick={() => setShowWarning(false)}
          >
            <X className="w-4 h-4 mr-2" />
            Tutup Informasi
          </Button>
        </div>
      </Modal>

      <Modal
        show={showPopupJalurMandiri}
        onClose={() => setShowPopupJalurMandiri(false)}
        className="lg:w-auto lg:max-w-[36rem] w-[95vw] dark:bg-slate-900 dark:border dark:border-slate-800"
      >
        {isJalurSkorUTBK ? (
          <FormSkorUTBK
            onClose={() => setShowPopupJalurMandiri(false)}
            selectedPeriode={selectedPeriode}
          />
        ) : isJalurSekolahLab ? (
          <FormSekolahLab
            onClose={() => setShowPopupJalurMandiri(false)}
            selectedPeriode={selectedPeriode}
          />
        ) : isJalurStudentExchange ? (
          <FormStudentExchange
            form={form}
            setForm={setForm}
            onClose={() => setShowPopupJalurMandiri(false)}
            selectedPeriode={selectedPeriode}
          />
        ) : (
          <form
            onSubmit={(event) => {
              event.preventDefault();
              setShowConfirmDaftar(true);
              setIsConfirm(false);
            }}
            className="flex flex-col gap-6 dark:text-slate-200"
          >
            <h1 className="mb-3 font-bold text-xl text-center text-slate-900 dark:text-white">
              {t("siswa.layout.register.title")}{" "}
              <span className="text-primary dark:text-blue-400">
                {selectedPeriode?.jalur_jenis?.nama_jalur_jenis}
              </span>
            </h1>
            <div>
              <Label required className="dark:text-slate-200">
                {t("siswa.layout.register.label.nama-lengkap")}
              </Label>
              <Input
                required
                placeholder={`type ${t(
                  "siswa.layout.register.label.nama-lengkap",
                )}...`}
                value={form.nama_lengkap}
                onChange={(event) =>
                  setForm((prev) => ({
                    ...prev,
                    nama_lengkap: event.target.value,
                  }))
                }
                className="dark:bg-slate-950 dark:border-slate-800 dark:text-white dark:placeholder:text-slate-500"
              />
              <p className="text-muted-foreground dark:text-slate-400 text-sm">
                {t("siswa.layout.register.label.nama-lengkap.description")}
              </p>
              <InputError
                text={error?.response?.data.errors?.nama_lengkap?.join(",")}
              />
            </div>

            {selectedPeriode?.jalur_jenis?.is_cek_pusat ? (
              <div>
                <Label className="dark:text-slate-200">Nomor UTBK</Label>
                <Input
                  placeholder="Nomor UTBK..."
                  value={form.nomor_utbk}
                  onChange={(event) =>
                    setForm((prev) => ({
                      ...prev,
                      nomor_utbk: event.target.value,
                    }))
                  }
                  className="dark:bg-slate-950 dark:border-slate-800 dark:text-white dark:placeholder:text-slate-500"
                />
                <InputError
                  text={error?.response?.data.errors?.nomor_utbk?.join(",")}
                />
              </div>
            ) : (
              ""
            )}
            {selectedPeriode?.jalur_jenis?.nama_jalur_jenis_slug?.startsWith(
              "profesi",
            ) ||
            selectedPeriode?.jalur_jenis?.nama_jalur_jenis_slug?.startsWith(
              "fasttrack",
            ) ? (
              <>
                <div>
                  <Label required className="dark:text-slate-200">
                    Asal Perguruan Tinggi/Universitas/Institusi
                  </Label>
                  <Combobox
                    serverSide
                    open={openAsalUniversitas}
                    setOpen={setOpenAsalUniversitas}
                    value={form.asal_pt || ""}
                    setValue={(newValue) => {
                      const selected = optionsPt?.find((option: Option) => {
                        return option?.value === newValue;
                      });
                      setSelectedAsalUniversitas(selected);
                      setForm((prev) => ({
                        ...prev,
                        asal_pt: newValue,
                      }));
                    }}
                    onChange={(event) =>
                      setSearchQueryUniversitas(event.target.value)
                    }
                    options={optionsPt}
                    placeholder="Pilih Asal Perguruan Tinggi"
                    isPending={isPendingOptionsPt}
                    searchQueryValue={searchQueryUniversitas || ""}
                  />
                </div>

                {selectedAsalUniversitas &&
                selectedAsalUniversitas?.nama_singkat?.startsWith(
                  `${web.univAcronym}`,
                ) ? (
                  <div>
                    <Label required className="dark:text-slate-200">
                      NIM {web.univAcronym}
                    </Label>
                    <Input
                      required
                      value={form.nim || ""}
                      placeholder="Ketik NIM..."
                      onChange={(event) =>
                        setForm((prev) => ({
                          ...prev,
                          nim: event.target.value,
                        }))
                      }
                      className="dark:bg-slate-950 dark:border-slate-800 dark:text-white dark:placeholder:text-slate-500"
                    />
                    <InputError
                      text={error?.response?.data?.errors?.nim?.join(",")}
                    />
                  </div>
                ) : (
                  <div>
                    <Label required className="dark:text-slate-200">
                      Asal Program Studi
                    </Label>
                    <Combobox
                      open={openAsalProdi}
                      setOpen={setOpenAsalProdi}
                      value={form.asal_prodi || ""}
                      setValue={(newValue) => {
                        setForm((prev) => ({
                          ...prev,
                          asal_prodi: newValue,
                        }));
                      }}
                      options={optionsAsalProdi}
                      placeholder="Pilih Asal Program Studi"
                      isPending={isPendingOptionsPt}
                    />
                    <InputError
                      text={error?.response?.data?.errors?.asal_prodi?.join(
                        ",",
                      )}
                    />
                  </div>
                )}
              </>
            ) : selectedPeriode?.jalur_jenis?.nama_jalur_jenis_slug?.startsWith(
                "rpl",
              ) ? (
              <>
                <div>
                  <Label className="dark:text-slate-200">NISN</Label>
                  <SegmentedInput
                    type="number"
                    length={10}
                    defaultValue={form.nisn}
                    onComplete={(value: string) => {
                      setForm((prev) => ({
                        ...prev,
                        nisn: value,
                      }));
                    }}
                  />
                  <InputError
                    text={error?.response?.data.errors?.nisn?.join(",")}
                  />
                  <div>
                    <p className="text-muted-foreground dark:text-slate-400">
                      NISN bisa anda lihat melalui link berikut
                    </p>
                    <Link
                      to="https://nisn.data.kemendikdasmen.go.id"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center gap-1.5 font-medium text-blue-600 dark:text-blue-400 hover:text-blue-700 dark:hover:text-blue-300 hover:underline transition-colors"
                    >
                      Cek NISN disini
                      <ExternalLink className="w-3.5 h-3.5" />
                    </Link>
                  </div>
                </div>

                <div>
                  <Label required className="dark:text-slate-200">
                    Apa jenjang pendidikan terakhir yang anda gunakan untuk
                    mendaftar RPL?
                  </Label>
                  <div className="mt-1 space-y-1">
                    <div className="flex space-x-3 items-center">
                      <Checkbox
                        required={!form.jenjang_pendidikan_terakhir_daftar_rpl}
                        checked={
                          form.jenjang_pendidikan_terakhir_daftar_rpl == "sma"
                        }
                        onCheckedChange={() =>
                          setForm((prev) => ({
                            ...prev,
                            jenjang_pendidikan_terakhir_daftar_rpl: "sma",
                          }))
                        }
                        className="dark:border-slate-600 dark:data-[state=checked]:bg-blue-600 dark:data-[state=checked]:text-white"
                      />
                      <span className="dark:text-slate-300">
                        SMA/MA/SMK Sederajat
                      </span>
                    </div>
                    <div className="flex space-x-3 items-center">
                      <Checkbox
                        required={!form.jenjang_pendidikan_terakhir_daftar_rpl}
                        checked={
                          form.jenjang_pendidikan_terakhir_daftar_rpl ==
                          "diploma"
                        }
                        onCheckedChange={() =>
                          setForm((prev) => ({
                            ...prev,
                            jenjang_pendidikan_terakhir_daftar_rpl: "diploma",
                          }))
                        }
                        className="dark:border-slate-600 dark:data-[state=checked]:bg-blue-600 dark:data-[state=checked]:text-white"
                      />
                      <span className="dark:text-slate-300">
                        Diploma 3 (D3)
                      </span>
                    </div>
                    <InputError
                      text={error?.response?.data.errors?.jenjang_pendidikan_terakhir_daftar_rpl?.join(
                        ",",
                      )}
                    />
                  </div>
                </div>

                <div>
                  <Label required className="dark:text-slate-200">
                    {t("siswa.layout.register.label.tahun-kelulusan")}
                  </Label>
                  <Input
                    required
                    type="number"
                    maxLength={4}
                    placeholder="contoh: 2025"
                    value={form.tahun_ijazah}
                    onChange={(event) => {
                      const numericValue = event.target.value.replace(
                        /\D/g,
                        "",
                      );

                      const finalValue = numericValue.slice(0, 4);

                      setForm((prev) => ({
                        ...prev,
                        tahun_ijazah: finalValue,
                      }));
                    }}
                    className="[&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none dark:bg-slate-950 dark:border-slate-800 dark:text-white dark:placeholder:text-slate-500"
                  />
                  <InputError
                    text={error?.response?.data.errors?.tahun_ijazah?.join(",")}
                  />
                </div>
                {form.jenjang_pendidikan_terakhir_daftar_rpl == "diploma" ? (
                  <div>
                    <Label required className="dark:text-slate-200">
                      Nomor Induk Mahasiswa (NIM) Asal
                    </Label>
                    <Input
                      required
                      value={form.nim || ""}
                      placeholder="Ketik Nomor Induk Mahasiswa (NIM) Asal..."
                      onChange={(event) =>
                        setForm((prev) => ({
                          ...prev,
                          nim: event.target.value,
                        }))
                      }
                      className="dark:bg-slate-950 dark:border-slate-800 dark:text-white dark:placeholder:text-slate-500"
                    />
                    <InputError
                      text={error?.response?.data?.errors?.nim?.join(",")}
                    />
                  </div>
                ) : (
                  ""
                )}
                <div>
                  <Label required className="dark:text-slate-200">
                    {t("siswa.layout.register.label.prodi")}
                  </Label>
                  <Combobox
                    open={openListProdi}
                    setOpen={setOpenListProdi}
                    value={form.uk_id || ""}
                    setValue={(value) => {
                      setForm((prev) => ({ ...prev, uk_id: value }));
                    }}
                    options={filteredOptionsProdi}
                    placeholder={`${t("siswa.layout.register.label.prodi")}`}
                  />
                  <InputError
                    text={error?.response?.data.errors?.uk_id?.join(",")}
                  />
                </div>
              </>
            ) : (
              <>
                {!selectedPeriode?.jalur_jenis?.nama_jalur_jenis_slug?.startsWith(
                  "internasional",
                ) ? (
                  <div>
                    <Label
                      className="dark:text-slate-200"
                      required={
                        selectedPeriode?.jalur_jenis?.nama_jalur_jenis_slug ==
                        "pascasarjana"
                          ? false
                          : true
                      }
                    >
                      NISN
                    </Label>
                    <SegmentedInput
                      type="number"
                      length={10}
                      defaultValue={form.nisn}
                      onComplete={(value: string) => {
                        setForm((prev) => ({
                          ...prev,
                          nisn: value,
                        }));
                      }}
                      // Add dark mode support for SegmentedInput slots
                    />
                    <InputError
                      text={error?.response?.data.errors?.nisn?.join(",")}
                    />
                    <div>
                      <p className="text-muted-foreground dark:text-slate-400">
                        NISN bisa anda lihat melalui link berikut
                      </p>
                      <Link
                        to="https://nisn.data.kemendikdasmen.go.id"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex items-center gap-1.5 font-medium text-blue-600 dark:text-blue-400 hover:text-blue-700 dark:hover:text-blue-300 hover:underline transition-colors"
                      >
                        Cek NISN disini
                        <ExternalLink className="w-3.5 h-3.5" />
                      </Link>
                    </div>
                  </div>
                ) : (
                  ""
                )}

                {selectedPeriode?.jalur_jenis?.nama_jalur_jenis_slug?.startsWith(
                  "pascasarjana",
                ) ||
                selectedPeriode?.jalur_jenis?.nama_jalur_jenis_slug?.startsWith(
                  "internasional",
                ) ? (
                  <>
                    <div>
                      <Label required className="dark:text-slate-200">
                        {t("siswa.layout.register.label.birthdate")}
                      </Label>
                      <Input
                        // required
                        type="date"
                        value={form.tanggal_lahir || "2001"}
                        onChange={(event) =>
                          setForm((prev) => ({
                            ...prev,
                            tanggal_lahir: event.target.value,
                          }))
                        }
                        className="dark:bg-slate-950 dark:border-slate-800 dark:text-white dark:[color-scheme:dark]"
                      />
                      <p className="text-primary dark:text-blue-400 font-semibold">
                        {form.tanggal_lahir &&
                          formatDateIndonesia(form.tanggal_lahir, "medium")}
                      </p>
                      <InputError
                        text={error?.response?.data?.errors?.tanggal_lahir?.join(
                          ",",
                        )}
                      />
                    </div>
                  </>
                ) : (
                  <>
                    <div>
                      <Label required className="dark:text-slate-200">
                        Tanggal Lahir
                      </Label>
                      <Input
                        required
                        type="date"
                        value={form.tanggal_lahir || "2001"}
                        onChange={(event) =>
                          setForm((prev) => ({
                            ...prev,
                            tanggal_lahir: event.target.value,
                          }))
                        }
                        className="dark:bg-slate-950 dark:border-slate-800 dark:text-white dark:[color-scheme:dark]"
                      />
                      <p className="text-primary dark:text-blue-400 font-semibold">
                        {form.tanggal_lahir &&
                          formatDateIndonesia(form.tanggal_lahir, "medium")}
                      </p>
                      <InputError
                        text={error?.response?.data?.errors?.tanggal_lahir?.join(
                          ",",
                        )}
                      />
                    </div>
                    <div>
                      <Label required className="dark:text-slate-200">
                        Sekolah Asal
                      </Label>
                      <Combobox
                        serverSide
                        open={openListSekolah}
                        setOpen={setOpenListSekolah}
                        value={form.id_ref_sekolah || ""}
                        setValue={(newValue) => {
                          const selected = dataSekolah?.find(
                            (option: Option) => {
                              return String(option.value) == String(newValue);
                            },
                          );
                          setSelectedSekolah(selected);
                          setForm((prev) => ({
                            ...prev,
                            id_ref_sekolah: newValue,
                            id_ref_jurusan_sekolah: "",
                          }));
                        }}
                        onChange={(event) =>
                          setSearchQuerySekolah(event.target.value)
                        }
                        options={dataSekolah}
                        placeholder="Pilih Sekolah"
                        isPending={isPendingSekolah}
                        searchQueryValue={searchQuerySekolah || ""}
                      />
                      <p className="text-muted-foreground dark:text-slate-400 font-semibold">
                        Cari berdasarkan nama sekolah atau NPSN Sekolah!
                      </p>
                      <InputError
                        text={error?.response?.data.errors?.id_ref_sekolah?.join(
                          ",",
                        )}
                      />
                    </div>

                    <div>
                      <Label required className="dark:text-slate-200">
                        Kurikulum yang digunakan?
                      </Label>
                      <div className="mt-2 flex gap-7">
                        <div className="flex gap-3 items-center">
                          <Checkbox
                            required={form.is_kurikulum_merdeka === null}
                            checked={form.is_kurikulum_merdeka === false}
                            onCheckedChange={(checked) => {
                              if (checked) {
                                setForm((prev) => ({
                                  ...prev,
                                  is_kurikulum_merdeka: false,
                                }));
                              } else {
                                setForm((prev) => ({
                                  ...prev,
                                  is_kurikulum_merdeka: null,
                                }));
                              }
                            }}
                            className="dark:border-slate-600"
                          />
                          <Label className="dark:text-slate-300">
                            Kurikulum 2013
                          </Label>
                        </div>
                        <div className="flex gap-3 items-center">
                          <Checkbox
                            required={form.is_kurikulum_merdeka === null}
                            checked={form.is_kurikulum_merdeka === true}
                            onCheckedChange={(checked) => {
                              if (checked) {
                                setForm((prev) => ({
                                  ...prev,
                                  is_kurikulum_merdeka: true,
                                }));
                              } else {
                                setForm((prev) => ({
                                  ...prev,
                                  is_kurikulum_merdeka: null,
                                }));
                              }
                            }}
                            className="dark:border-slate-600"
                          />
                          <Label className="dark:text-slate-300">
                            Kurikulum Merdeka
                          </Label>
                        </div>
                        {!isSMK && (
                          <div className="flex gap-3 items-center">
                            <Checkbox
                              required={form.is_kurikulum_merdeka === null}
                              checked={form.is_kurikulum_merdeka == 2}
                              onCheckedChange={(checked) => {
                                if (checked) {
                                  setForm((prev) => ({
                                    ...prev,
                                    is_kurikulum_merdeka: 2,
                                  }));
                                } else {
                                  setForm((prev) => ({
                                    ...prev,
                                    is_kurikulum_merdeka: null,
                                  }));
                                }
                              }}
                              className="dark:border-slate-600"
                            />
                            <Label className="dark:text-slate-300">
                              Lainnya
                            </Label>
                          </div>
                        )}
                      </div>
                    </div>
                    {form.is_kurikulum_merdeka !== null &&
                      (isSMK ||
                        (isSMA && form.is_kurikulum_merdeka == false) ||
                        (!isSMA &&
                          !isSMK &&
                          form.is_kurikulum_merdeka == false)) && (
                        <div>
                          <Label required className="dark:text-slate-200">
                            Jurusan/Program Keahlian Sekolah
                          </Label>
                          <Combobox
                            isPending={isPendingListJurusan}
                            open={openListJurusan}
                            setOpen={setOpenListJurusan}
                            value={form.id_ref_jurusan_sekolah || ""}
                            setValue={(value) => {
                              setForm((prev) => ({
                                ...prev,
                                id_ref_jurusan_sekolah: value,
                              }));
                              setSelectedMapels([]);
                            }}
                            options={filteredListJurusan}
                            placeholder="Pilih jurusan sekolah"
                          />
                          <InputError
                            text={error?.response?.data.errors?.id_ref_jurusan_sekolah?.join(
                              ",",
                            )}
                          />
                        </div>
                      )}

                    {(isSMA && form.is_kurikulum_merdeka) ||
                    (!isSMA && !isSMK && form.is_kurikulum_merdeka) ||
                    (!isSMA && !isSMK && form.is_kurikulum_merdeka === 2) ? (
                      <div>
                        <Label required className="dark:text-slate-200">
                          Mapel Peminatan Kurikulum Merdeka (Minimal 4, Maksimal
                          5)
                        </Label>
                        <MultiSelect
                          options={listMapelPeminatan || []}
                          onValueChange={(value) => {
                            setSelectedMapels(value);
                            setForm((prev) => ({
                              ...prev,
                              id_ref_jurusan_sekolah: "",
                            }));
                          }}
                          defaultValue={selectedMapels}
                          placeholder="Pilih Mapel Peminatan"
                          variant="inverted"
                          animation={2}
                          maxCount={3}
                          // Pastikan MultiSelect support dark mode props atau class
                          className="dark:bg-slate-950 dark:border-slate-800 dark:text-white"
                        />
                        <InputError
                          text={error?.response?.data.errors?.list_id_ref_mapel_peminatan_kurikulum_merdeka?.join(
                            ",",
                          )}
                        />
                      </div>
                    ) : (
                      ""
                    )}
                  </>
                )}

                {/* {isPKBM && ( */}

                {/* )} */}
                <div>
                  <Label required className="dark:text-slate-200">
                    {t("siswa.layout.register.label.tahun-kelulusan")}
                  </Label>
                  <Input
                    required
                    type="number"
                    maxLength={4}
                    placeholder="contoh: 2025"
                    value={form.tahun_ijazah}
                    onChange={(event) => {
                      const numericValue = event.target.value.replace(
                        /\D/g,
                        "",
                      );

                      const finalValue = numericValue.slice(0, 4);

                      setForm((prev) => ({
                        ...prev,
                        tahun_ijazah: finalValue,
                      }));
                    }}
                    className="[&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none dark:bg-slate-950 dark:border-slate-800 dark:text-white dark:placeholder:text-slate-500"
                  />
                  <InputError
                    text={error?.response?.data.errors?.tahun_ijazah?.join(",")}
                  />
                </div>
              </>
            )}

            {selectedPeriode?.jalur_jenis?.nama_jalur_jenis_slug?.startsWith(
              "pascasarjana",
            ) ||
            selectedPeriode?.jalur_jenis?.nama_jalur_jenis_slug?.startsWith(
              "internasional",
            ) ? (
              <>
                <div>
                  <Label className="dark:text-slate-200">
                    {t("siswa.layout.register.label.jenjang")}
                  </Label>
                  <Combobox
                    open={openListJenjang}
                    setOpen={setOpenListJenjang}
                    value={selectedJenjang}
                    setValue={(value) => {
                      setSelectedJenjang(value);
                    }}
                    options={filteredOptionsJenjang}
                    placeholder={`${t("siswa.layout.register.label.jenjang")}`}
                  />
                </div>
                <div
                  className={`${
                    selectedJenjang ? "" : "opacity-30 pointer-events-none"
                  }`}
                >
                  <Label className="dark:text-slate-200">
                    {t("siswa.layout.register.label.prodi")}
                  </Label>
                  <Combobox
                    open={openListProdi}
                    setOpen={setOpenListProdi}
                    value={form.uk_id || ""}
                    setValue={(value) => {
                      setForm((prev) => ({ ...prev, uk_id: value }));
                    }}
                    options={filteredOptionsProdi}
                    placeholder={`${t("siswa.layout.register.label.prodi")}`}
                  />
                </div>
              </>
            ) : !selectedPeriode?.jalur_jenis?.nama_jalur_jenis_slug?.startsWith(
                "profesi",
              ) ? (
              <></>
            ) : (
              ""
            )}

            <div className="mt-5 flex gap-3">
              <Button
                type="button"
                variant={"outline"}
                onClick={() => {
                  setShowPopupJalurMandiri(false);
                }}
                className="dark:bg-transparent dark:border-slate-700 dark:text-slate-300 dark:hover:bg-slate-800 dark:hover:text-white"
              >
                {t("siswa.layout.register.button.batal")}
              </Button>
              <Button
                variant={"default"}
                className="dark:bg-slate-50 dark:text-slate-900 dark:hover:bg-slate-200"
              >
                {t("siswa.layout.register.button.daftar")}
              </Button>
            </div>
          </form>
        )}
      </Modal>

      <Modal
        className="w-[95vw] max-w-2xl"
        show={showConfirmDaftar}
        onClose={() => {
          setShowConfirmDaftar(false);
          // setIsConfirm(false);
        }}
      >
        <div className="p-1 sm:p-2">
          <FormHeader
            title={`${t("siswa.layout.register.confirmation.title")} ${
              selectedPeriode?.jalur_jenis?.nama_jalur_jenis
            }`}
            icon={<MdWarning className="text-amber-500 w-6 h-6" />}
          />

          <form
            onSubmit={handleSubmitPendaftaran}
            className="mt-6 flex flex-col gap-6"
          >
            {/* KONDISI: Jalur Mandiri SMBJM */}
            {isJalurGrupSMBJM ? (
              <div className="flex flex-col gap-6">
                {/* Box Detail Data Peserta */}
                <div className="bg-slate-50 dark:bg-slate-900/50 rounded-xl p-5 border border-slate-200 dark:border-slate-800">
                  <h4 className="text-sm font-bold text-slate-800 dark:text-slate-200 mb-4 uppercase tracking-wider border-b border-slate-200 dark:border-slate-800 pb-2">
                    Verifikasi Data Anda
                  </h4>

                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-y-4 gap-x-6">
                    <div className="flex flex-col gap-1">
                      <span className="text-xs font-semibold text-slate-500 uppercase">
                        Nama Lengkap
                      </span>
                      <span className="text-sm font-medium text-slate-900 dark:text-slate-100">
                        {form.nama_lengkap}
                      </span>
                    </div>

                    <div className="flex flex-col gap-1">
                      <span className="text-xs font-semibold text-slate-500 uppercase">
                        NISN
                      </span>
                      <span className="text-sm font-mono font-medium text-slate-900 dark:text-slate-100">
                        {form.nisn}
                      </span>
                    </div>

                    <div className="flex flex-col gap-1 sm:col-span-2">
                      <span className="text-xs font-semibold text-slate-500 uppercase">
                        Asal Sekolah
                      </span>
                      <span className="text-sm font-medium text-slate-900 dark:text-slate-100">
                        {selectedSekolah?.label}
                      </span>
                    </div>

                    <div className="flex flex-col gap-1">
                      <span className="text-xs font-semibold text-slate-500 uppercase">
                        Tahun Kelulusan
                      </span>
                      <span className="text-sm font-medium text-slate-900 dark:text-slate-100">
                        {form.tahun_ijazah}
                      </span>
                    </div>

                    {form.is_kurikulum_merdeka && isSMA && (
                      <div className="flex flex-col gap-1 sm:col-span-2">
                        <span className="text-xs font-semibold text-slate-500 uppercase">
                          Mapel Peminatan
                        </span>
                        {currentMapels && currentMapels?.length > 0 ? (
                          <div className="flex flex-wrap gap-2 mt-1">
                            {currentMapels?.map(
                              (option: Option, idx: number) => (
                                <Badge
                                  key={idx}
                                  variant="secondary"
                                  className="font-medium bg-white dark:bg-slate-800 border-slate-200 dark:border-slate-700"
                                >
                                  {option.label}
                                </Badge>
                              ),
                            )}
                          </div>
                        ) : (
                          <span className="text-sm font-medium text-red-500 flex items-center gap-1 mt-1">
                            <MdWarning /> Mapel Peminatan belum dipilih!
                          </span>
                        )}
                      </div>
                    )}

                    {(isSMK || !form.is_kurikulum_merdeka) && (
                      <div className="flex flex-col gap-1 sm:col-span-2">
                        <span className="text-xs font-semibold text-slate-500 uppercase">
                          Jurusan / Program Keahlian
                        </span>
                        {currentJurusan ? (
                          <span className="text-sm font-medium text-slate-900 dark:text-slate-100 mt-1">
                            {currentJurusan?.label}
                          </span>
                        ) : (
                          <span className="text-sm font-medium text-red-500 flex items-center gap-1 mt-1">
                            <MdWarning /> Jurusan Sekolah Asal belum dipilih!
                          </span>
                        )}
                      </div>
                    )}
                  </div>
                </div>

                {/* Box Konfirmasi (Checkbox) */}
                <div
                  className={`p-4 sm:p-5 rounded-xl border transition-colors duration-200 ${isConfirm ? "bg-emerald-50 border-emerald-200 dark:bg-emerald-950/20 dark:border-emerald-900/50" : "bg-amber-50 border-amber-200 dark:bg-amber-950/20 dark:border-amber-900/50"}`}
                >
                  <label className="flex items-start gap-3 cursor-pointer group">
                    <div className="mt-0.5">
                      <Checkbox
                        checked={isConfirm}
                        onCheckedChange={(checked) =>
                          setIsConfirm(checked ? true : false)
                        }
                        className={`data-[state=checked]:bg-emerald-600 data-[state=checked]:border-emerald-600 ${!isConfirm && "border-amber-500"}`}
                      />
                    </div>
                    <div className="flex flex-col gap-1">
                      <span className="text-sm font-bold uppercase tracking-wide text-slate-900 dark:text-slate-100">
                        Pernyataan Persetujuan
                      </span>
                      <span
                        className={`text-sm leading-relaxed transition-colors ${isConfirm ? "text-emerald-800 dark:text-emerald-300" : "text-amber-800 dark:text-amber-400"}`}
                      >
                        Dengan ini saya menyatakan NISN, Nama, Tahun Kelulusan,
                        Sekolah, Jurusan/Program Keahlian Sekolah{" "}
                        <strong>sudah benar</strong>, saya dinyatakan{" "}
                        <strong>TIDAK LULUS</strong> pada jalur SNBP tahun{" "}
                        {selectedPeriode?.tahun}, serta tidak{" "}
                        <strong>MENDAFTAR KEMBALI</strong> pada jalur SNBT tahun{" "}
                        {selectedPeriode?.tahun}.
                      </span>
                    </div>
                  </label>
                </div>
              </div>
            ) : (
              /* KONDISI: Selain Jalur Mandiri SMBJM */
              <div
                className={`p-4 sm:p-5 rounded-xl border transition-colors duration-200 ${isConfirm ? "bg-emerald-50 border-emerald-200 dark:bg-emerald-950/20 dark:border-emerald-900/50" : "bg-amber-50 border-amber-200 dark:bg-amber-950/20 dark:border-amber-900/50"}`}
              >
                <label className="flex items-start gap-3 cursor-pointer group">
                  <div className="mt-0.5">
                    <Checkbox
                      checked={isConfirm}
                      onCheckedChange={(checked) =>
                        setIsConfirm(checked ? true : false)
                      }
                      className={`data-[state=checked]:bg-emerald-600 data-[state=checked]:border-emerald-600 ${!isConfirm && "border-amber-500"}`}
                    />
                  </div>
                  <span
                    className={`text-sm font-medium leading-relaxed transition-colors ${isConfirm ? "text-emerald-800 dark:text-emerald-300" : "text-amber-800 dark:text-amber-400"}`}
                  >
                    {t("siswa.layout.register.confirmation.check")}
                  </span>
                </label>
              </div>
            )}

            {/* Action Buttons */}
            <div className="flex flex-col-reverse sm:flex-row justify-end gap-3 pt-4 border-t border-slate-100 dark:border-slate-800 mt-2">
              <Button
                type="button"
                variant="outline"
                className="w-full sm:w-auto"
                onClick={() => {
                  setShowConfirmDaftar(false);
                  setIsConfirm(false);
                }}
                disabled={isPendingStorePendaftaran}
              >
                {t("guest.layout.button.back")}
              </Button>

              <Button
                type="submit"
                className="w-full sm:w-auto min-w-[140px]"
                disabled={isPendingStorePendaftaran || !isConfirm}
                variant="default"
              >
                {isPendingStorePendaftaran ? (
                  <>
                    <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                    Processing...
                  </>
                ) : (
                  t("siswa.layout.register.confirmation.button")
                )}
              </Button>
            </div>
          </form>
        </div>
      </Modal>
    </main>
  );
}
